import React, { useContext } from 'react';

import { t as translate } from 'i18next';

import { COLLABORATORS_STATUS } from '../../../../../../constants/collaborators';
import { CompanyContext } from '../../../../../../context/company/companyContext';
import { IMembersData } from '../../../../../../interfaces/businessData';
import {
  TRANSLATION_COLLABORATORS,
  TRANSLATIONS_COLLABORATOR_STATUS_V3
} from '../../../../../../translations/collaborators';
import { formatDateForDisplay } from '../../../../../../utils/datetime/datetime';
import BdsLabelPill from '../../../../BdsLabelPill/BdsLabelPill';
import BdsTooltip from '../../../../BdsTooltip/BdsTooltip';

interface ICollaboratorStatusCellProps {
  collaborator: IMembersData;
}

const CollaboratorStatusCell: React.FC<ICollaboratorStatusCellProps> = ({ collaborator }) => {
  const { isUSA } = useContext(CompanyContext);

  const displayLabelPill = () => {
    return (
      <BdsLabelPill
        text={translate(TRANSLATIONS_COLLABORATOR_STATUS_V3[collaborator.status])?.toUpperCase()}
        variant={COLLABORATORS_STATUS[collaborator.status].tagVariant}
        iconLeft={COLLABORATORS_STATUS[collaborator.status].icon}
      />
    );
  };

  return (
    <div style={{ minWidth: 135 }}>
      {collaborator.status === 'pending' && collaborator.planStartDate ? (
        <BdsTooltip
          message={translate(TRANSLATION_COLLABORATORS.table.tooltips.pendingCollaborator, {
            activation_date: formatDateForDisplay(collaborator.planStartDate, isUSA ?? false, '-')
          })}
          position="bottom-left"
        >
          {displayLabelPill()}
        </BdsTooltip>
      ) : (
        displayLabelPill()
      )}
    </div>
  );
};

export default CollaboratorStatusCell;
